export default function EFAddress(props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.2583 16.1323C12.4173 16.9943 11.5137 17.7841 10.6103 18.4826C10.3637 18.6733 10.1313 18.8461 9.91671 19C9.70216 18.8461 9.46972 18.6733 9.22314 18.4826C8.31975 17.7841 7.41607 16.9943 6.5751 16.1323C4.22578 13.7243 2.83337 11.2455 2.83337 8.8782C2.83337 5.07947 6.00469 2 9.91671 2C13.8287 2 17 5.07947 17 8.8782C17 11.2455 15.6076 13.7243 13.2583 16.1323ZM13 9C13 10.6569 11.6569 12 10 12C8.34315 12 7 10.6569 7 9C7 7.34315 8.34315 6 10 6C11.6569 6 13 7.34315 13 9Z"
                fill="#919191"
            />
        </svg>
    );
}
